var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',_vm._b({attrs:{"disabled":_vm.isDisabled,"type":"submit"},on:{"click":_vm.onClick}},'btn',_vm.$attrs,false),[_vm._t("content",function(){return [_c('div',{staticClass:"content"},[_vm._t("default")],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }